/**
 * "↑ Highest" / "↓ Lowest" — one click flips which end of a metric ranks
 * first (02/11/2026, the user: "keep the same BUT based on the least"). Quiet
 * outline while the highest wins, tinted when the lowest does; the arrow
 * turns over.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { ArrowUp } from 'lucide-react';

import { cn } from '@/lib/utils';

interface Props {
  lowest: boolean;
  /** The metric's name, for the title. */
  name: string;
  onChange: (lowest: boolean) => void;
}

export const LowestToggle: FC<Props> = ({ lowest, name, onChange }) => (
  <button
    type="button"
    aria-pressed={lowest}
    data-testid="formula-lowest-toggle"
    onClick={() => onChange(!lowest)}
    title={lowest ? `Lowest ${name} ranks first — click to rank the highest first` : `Highest ${name} ranks first — click to rank the lowest first`}
    className={cn(
      'inline-flex h-9 w-[5.75rem] shrink-0 items-center justify-center gap-1.5 rounded-md text-xs font-medium transition-colors motion-reduce:transition-none',
      lowest ? 'bg-primary/10 text-primary ring-1 ring-inset ring-primary/25' : 'border border-input text-muted-foreground hover:text-foreground',
    )}
  >
    <ArrowUp className={cn('h-3.5 w-3.5 transition-transform duration-200 motion-reduce:transition-none', lowest && 'rotate-180')} aria-hidden />
    {lowest ? 'Lowest' : 'Highest'}
  </button>
);
